// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1aCss","unreadBadge":"styles_unreadBadge__2qhwF","modalContent":"styles_modalContent__13TNE","modal":"styles_modal__248pE"};